import { GESTION_OPERATIVA_SYNC_HISTORY } from './constants'
import { getCliente } from './getCliente'
import { getAuto } from './getAuto'

export function syncHistory(data) {
  return (dispatch, getState) => {
    dispatch({
      type: GESTION_OPERATIVA_SYNC_HISTORY,
      data,
    })
    if (data.client_id) {
      dispatch(getCliente(data.client_id))
    }
    if (data.catalog_id) {
      dispatch(getAuto(data.catalog_id, { pricing: true, files: true, simulador: true }))
    }
  }
}

export function reducer(state, action) {
  if (action.type === GESTION_OPERATIVA_SYNC_HISTORY) {
      return {
        ...state,
        ...action.data,
      }
  }
  else {
        return state
  }
}
